// extracted by mini-css-extract-plugin
module.exports = {"bottomLayer":"AdminOnboardingBottomArea_bottomLayer__vrbLb","bottomLink":"AdminOnboardingBottomArea_bottomLink___Yd6v"};